import { type Client, createClient } from 'graphql-ws';

import { getRelayExperimentalApis } from '@atlassian/relay-experimental-apis';

import { WS_CLIENT_KEEP_ALIVE, WS_CLIENT_RETRIES } from '../../constants';
import { getAggSubscriptionEndpoint, isSSR } from '../index';

let client: Client | null;

export const getClient = (): Client | null => {
	if (isSSR()) {
		return null;
	}

	if (!client) {
		client = createClient({
			url: getAggSubscriptionEndpoint(),
			lazy: true,
			keepAlive: WS_CLIENT_KEEP_ALIVE,
			retryAttempts: WS_CLIENT_RETRIES,
			connectionParams: {
				'atl-client-name': 'jira-frontend',
				'atl-client-version': `${(window as any)?.BUILD_KEY ?? ''}::${(window as any)?.SSR_BUILD_KEY ?? ''}`,
				'X-ExperimentalApi': getRelayExperimentalApis().join(','),
			},
		});
	}
	return client;
};

export const cleanUpClient = (): void => {
	client = null;
};
